module.exports = __webpack_public_path__ + "img/234.f8184740.jpg";